export default __webpack_public_path__ + "0ca13f572837d12bf565cb21fd5a1f71.png";